import { backendFetch } from '../../../backend/backend';
import React, { useState, useEffect, Fragment } from 'react';

import { TSTable, TSCell } from '../../ui/TableStructure';
import { TableRow, Paper, Typography, Container } from '@mui/material';

const StatsSeats=()=>{
	const maxDataPixels=850;
	const [playerToRightResults,setPlayerToRightResults]=useState();
	const [players,setPlayers]=useState();

	useEffect(()=>{
		const fetchData=async ()=> {
			const results=await backendFetch('stats/playertoright');
			setPlayerToRightResults(results);
			setPlayers(Object.keys(results));
		}
		 
		fetchData();
	},[]);

	return(
		<Fragment>
			{playerToRightResults && players &&
				<Fragment>
					<TSTable title="Comparison with Player to Right" headings={["Player"].concat(players)} sx={{width:{xs:"100%",sm:1065}}}>
						{players.map((p)=>(
							<TableRow key={p.name}>
								<TSCell>{p}</TSCell>
								{players.map((o)=>(
									p!==o ?  <TSCell sx={{width:`${(maxDataPixels/players.length).toFixed(0)}px`}}>{playerToRightResults[p][o].wins}/{playerToRightResults[p][o].losses}</TSCell> : <TSCell/> 
								))}
							</TableRow>
						))}
					</TSTable>
					<Paper>
						<Container>
							<Typography variant="body">
								The table above shows the record of the player down the left side of the table against the opponent across the top,
								when the opponent starts the game positioned immediately to the right of the player.
							</Typography>
						</Container>
						<Container>
							<Typography variant="body">
								Each cell contains "wins/losses" indicating how many times the player did better than the opponent, vs how many time the player did worse.
							</Typography>
						</Container>
					</Paper>
				</Fragment>
			}
		</Fragment>
	)
}

export default StatsSeats;
